import { memo, useCallback, useEffect, useState } from "react";
import TemporaryDrawer from "../ui/temp-drawer.component";
import { disableBodyScroll, enableBodyScroll } from "../../utils/HtmlHelper";
import LeverageItems from "./leverage-items";
import { toastCustomError } from "../../utils/ToastUtils";
import { useGetCollectibleByCodeQuery, useGetCollectibleQuery } from "../../apis/collectibles.api";
import { LeverageValues } from "../../models/RushGame";

interface LeverageProps {
  isPlaying: boolean,
  leverage: number,
  setLeverage: (newLeverage: number) => void;
}

const Leverage: React.FC<LeverageProps> = ({isPlaying, leverage, setLeverage}) => {
  return (

    <div className="flat-card !py-0 !px-4 flex flex-col flex-1 center justify-center gap-1 !pb-1">

      <p className="text-xs text-gray-700 pt-1">
        Leverage
      </p>

      {/* Leverage Selector */}
      <LeverageSelector isPlaying={isPlaying} leverage={leverage} setLeverage={setLeverage}/>

    </div>

  );
}

export default Leverage;

interface LeverageSelectorProps {
  isPlaying: boolean,
  leverage: number,
  setLeverage: (newLeverage: number) => void;
}

interface LeverageItem {
  value:number,
  isLocked: boolean,
  unlockMessage: string
}

const LeverageSelector = memo<LeverageSelectorProps>(({isPlaying, leverage, setLeverage}) => {

  const {data: card} = useGetCollectibleByCodeQuery("BTC");

  const [leverageValues, setLeverageValues] = useState<LeverageItem[]>([]);

  useEffect(() => {

    const isLastCardUnlocked = card ? card?.step > 0 : false;

    const leverageValuesData = [
      { value: LeverageValues.VALUE_1, isLocked:false, unlockMessage:""},
      { value: LeverageValues.VALUE_2, isLocked:false, unlockMessage:""},
      { value: LeverageValues.VALUE_3, isLocked:false, unlockMessage:""},
      { value: LeverageValues.VALUE_4, isLocked:!isLastCardUnlocked, unlockMessage:"Require Bitcoin Collectible card at Bronze rank to unlock"},
    ]

    setLeverageValues(leverageValuesData);

  }, [card])

  const [openDrawer, setOpenDrawer] = useState(false);

  const money = true;

  const handleOnClick = useCallback((leverage: number) => {
    setLeverage(leverage);
    setOpenDrawer(false);
  }, [setLeverage]);

  function isLockedItem(value:number){
    return true;
  }

  return(
    <TemporaryDrawer
      title={'Leverage'}
      anchor={'bottom'}
      size={'auto'}
      className={'w-full flex'}
      buttonClass={"w-full pb-2"}
      element={
        <div className="w-full center" onClick={() => setOpenDrawer(true)}>
          <LeverageItems value={leverage}/>
        </div>
      }
      open={openDrawer}
      onOpen={() => {
        disableBodyScroll();
        setOpenDrawer(true);
      }}
      onClose={() => {
        enableBodyScroll();
        setOpenDrawer(false)
      }}
    >

      <div className={"w-full h-full overflow-y-auto mb-8"}>

        <h3 className="text-2xl center text-center">Enhance your result with a leverage effect</h3>
        <p className="mt-2 text-base center text-center text-grey-700">Works for positive and negative score</p>

        <div className="w-3/4 mx-auto">

          { isPlaying &&
            <div className="flex center w-full mt-5">
              <p>
                Your trade is not closed yet...
              </p>
            </div>
          }

          {/* Amount values */}
          { !isPlaying && money &&
            <div className="grid grid-cols-2 gap-x-3 gap-y-6 mt-6 mb-2">

              { leverageValues.map((item, index) => (

                <div key={index} className="w-full center mx-auto"
                  onClick={() => {
                    if ( item.isLocked ) {
                      toastCustomError(item.unlockMessage);
                    } else {
                      handleOnClick(item.value);
                    }
                  }}
                >
                  <LeverageItems value={item.value} isLocked={item.isLocked}/>
                </div>

              )) }
            </div>
          }

        </div>

      </div>

    </TemporaryDrawer>
  )
})
